/* Shared mock data for the Clinic Pulse walkthrough.
   Numbers and clinic names are intentionally different from any real customer data. */

export const CP_PERIOD = "Feb 2026";
export const CP_COMPARE = "vs Jan 2026 (MoM) · vs Feb 2025 (YoY)";

export const CP_LOCATIONS = [
  { name: "Riverside", color: "#0d9488" },
  { name: "Beachview", color: "#2563eb" },
  { name: "Hilltop",   color: "#f59e0b" },
  { name: "Northgate", color: "#ec4899" },
  { name: "Lakeshore", color: "#f97316" },
];

/* AI Insights — 6 signals (Wins · Watches · Actions) */
export const CP_SIGNALS = [
  { tone: "win",    title: "Top Revenue",       chip: "Win",    body: "Lakeshore leads with $231,560 this month",        foot: "1,832 invoices · $7,470/day" },
  { tone: "win",    title: "Best Collection",   chip: "Win",    body: "Beachview at 97.8% collection rate",              foot: "$141,640 collected of $144,890" },
  { tone: "win",    title: "Revenue Growth",    chip: "Win",    body: "Northgate revenue up 22.4% MoM",                  foot: "$128,940 this month" },
  { tone: "watch",  title: "Capacity Planning", chip: "Watch",  body: "Beachview — 5 PTs at 248.2 avg apts each",        foot: "High utilisation — consider adding capacity" },
  { tone: "action", title: "High Cancellation", chip: "Action", body: "Hilltop — 21.2% cancellation rate (267 cancelled)", foot: "Above 15% threshold — review scheduling" },
  { tone: "action", title: "High Cancellation", chip: "Action", body: "Northgate — 15.4% cancellation rate (228 cancelled)", foot: "Just above threshold — monitor trend" },
];

/* Appointments tab */
export const CP_APPTS = {
  totals: [
    { label: "Total Appointments", value: "7,338", mom: { dir: "down", val: "1.4%" }, yoy: { dir: "up", val: "12.8%" }, tint: "emerald" },
    { label: "Completed / Billed", value: "6,025", sub: "82% rate",                  tint: "emerald-soft" },
    { label: "No-Shows",           value: "81",    sub: "1.1% rate",                 tint: "rose" },
    { label: "Unique Patients",    value: "2,918", mom: { dir: "up", val: "2.6%" },  tint: "sky" },
  ],
  subKpis: [
    { label: "Total Assessments", value: "635",   sub: "8.7% of all apts", accent: "indigo", action: "Click to drill down" },
    { label: "Total Assessments", value: "541",   sub: "85% of scheduled", accent: "emerald", action: "= Scoreboard count" },
    { label: "Total Treatments",  value: "6,703", sub: "91.3% of all apts",accent: "indigo", action: "Click to drill down" },
    { label: "Total Treatments",  value: "5,484", sub: "82% of scheduled", accent: "emerald", action: "= Scoreboard count" },
    { label: "Cancelled",         value: "898",   sub: "12.2%" },
    { label: "Dismissed",         value: "235",   sub: "3.2%" },
    { label: "AVG / DAY",         value: "236.7", sub: "31 days" },
    { label: "Practitioners",     value: "46",    sub: "159.5 avg each" },
  ],
  byLocation: [
    { loc: "Riverside", apts: 1067 },
    { loc: "Beachview", apts: 1241 },
    { loc: "Hilltop",   apts: 1260 },
    { loc: "Northgate", apts: 1478 },
    { loc: "Lakeshore", apts: 2292 },
  ],
  assessTreat: [
    { loc: "Riverside", ax: "98/82",   tx: "905/772"   },
    { loc: "Beachview", ax: "123/108", tx: "1148/972"  },
    { loc: "Hilltop",   ax: "115/100", tx: "1162/942"  },
    { loc: "Northgate", ax: "144/124", tx: "1351/1107" },
    { loc: "Lakeshore", ax: "186/170", tx: "2048/1726" },
  ],
};

/* Revenue tab */
export const CP_REVENUE = {
  totals: [
    { label: "Total Revenue", value: "$754,520", mom: { dir: "up", val: "4.8%" }, tint: "emerald" },
    { label: "Collected",     value: "$718,302", sub: "95.2% rate",                tint: "emerald-soft" },
    { label: "Outstanding",   value: "$36,218",  sub: "4.8% of billed",            tint: "amber" },
    { label: "Rev / Day",     value: "$24,339",  sub: "31 days",                   tint: "sky" },
  ],
  subKpis: [
    { label: "Total Invoices",     value: "6,562",  sub: "Billed this month" },
    { label: "Avg Invoice",        value: "$115",   sub: "Per invoice" },
    { label: "Rev / Patient",      value: "$259",   sub: "2,918 patients" },
    { label: "Rev / Practitioner", value: "$16,403",sub: "46 practitioners" },
  ],
  byLocation: [
    { loc: "Riverside", rev: 103420, collect: 94.9 },
    { loc: "Beachview", rev: 144890, collect: 97.8 },
    { loc: "Hilltop",   rev: 145710, collect: 95.3 },
    { loc: "Northgate", rev: 128940, collect: 95.1 },
    { loc: "Lakeshore", rev: 231560, collect: 94.6 },
  ],
};

/* Practitioners tab */
export const CP_PRACT = {
  totals: [
    { label: "Active Practitioners",   value: "46",     tint: "indigo" },
    { label: "Avg Apts / Practitioner", value: "159.5", tint: "emerald" },
    { label: "Total Appointments",     value: "7,338",  tint: "sky" },
    { label: "Unique Patients",        value: "2,918",  tint: "emerald-soft" },
  ],
  table: [
    { loc: "Riverside", p: 8,  apts: 1067, avg: 133.4, pts: 478, rev: "$103,420", rpp: "$12,928" },
    { loc: "Beachview", p: 5,  apts: 1241, avg: 248.2, pts: 553, rev: "$144,890", rpp: "$28,978" },
    { loc: "Hilltop",   p: 7,  apts: 1260, avg: 180.0, pts: 562, rev: "$145,710", rpp: "$20,816" },
    { loc: "Northgate", p: 9,  apts: 1478, avg: 164.2, pts: 602, rev: "$128,940", rpp: "$14,327" },
    { loc: "Lakeshore", p: 17, apts: 2292, avg: 134.8, pts: 993, rev: "$231,560", rpp: "$13,621" },
  ],
};

/* Franchise tab — group-level rollup (multi-franchise model) */
export const CP_FRANCHISE = {
  totals: [
    { label: "Active Franchises",    value: "3",          tint: "indigo" },
    { label: "Royalty Revenue · MTD",value: "$52,816",    sub: "7% of group revenue",                      tint: "emerald" },
    { label: "Brand Compliance",     value: "92%",        sub: "across all franchises",                    tint: "sky" },
    { label: "Prospect Pipeline",    value: "4",          sub: "in onboarding stage",                       tint: "amber" },
  ],
  subKpis: [
    { label: "Avg Franchise Revenue", value: "$251,507", sub: "per franchise group" },
    { label: "Top Franchise",         value: "Apex North", sub: "Lakeshore + Northgate" },
    { label: "Highest Royalty Rate",  value: "8.0%",     sub: "Apex Lakefront tier" },
    { label: "Audits Passed",         value: "11/12",    sub: "Last 90 days" },
  ],
  table: [
    {
      name: "Apex North",
      locs: "Lakeshore · Northgate",
      pract: 26,
      apts: 3770,
      revenue: "$360,500",
      royaltyRate: "7.0%",
      royalty: "$25,235",
      compliance: 94,
      compTone: "win",
    },
    {
      name: "Apex West",
      locs: "Riverside · Hilltop",
      pract: 15,
      apts: 2327,
      revenue: "$249,130",
      royaltyRate: "7.0%",
      royalty: "$17,439",
      compliance: 89,
      compTone: "watch",
    },
    {
      name: "Apex Lakefront",
      locs: "Beachview",
      pract: 5,
      apts: 1241,
      revenue: "$144,890",
      royaltyRate: "8.0%",
      royalty: "$11,591",
      compliance: 96,
      compTone: "win",
    },
  ],
};

/* Ask AI mock */
export const CP_ASK_AI = {
  user: "Which locations should we focus on this quarter to lift revenue?",
  ai: {
    summary: "Based on Feb 2026 performance vs. Jan 2026 across your 5 locations, here are 3 areas of focus:",
    sections: [
      {
        heading: "Address cancellation patterns",
        bullets: [
          "Hilltop has the highest cancellation rate at 21.2% — 267 cancellations in Feb.",
          "Northgate is just above the 15% threshold (228 cancellations).",
          "Recommend SMS confirmation flow + auto-reschedule on cancel — could recover ~$28k/month combined.",
        ],
      },
      {
        heading: "Expand capacity at top performers",
        bullets: [
          "Beachview is at 248.2 avg appointments per practitioner — highest in the group.",
          "Adding 2 more PTs at Beachview could unlock ~$48k/month at current revenue/practitioner.",
        ],
      },
      {
        heading: "Replicate Lakeshore's playbook",
        bullets: [
          "Lakeshore is your strongest location ($231k MTD, 17 PTs, $13.6k rev/practitioner).",
          "Apply Lakeshore's intake + recall flow to Riverside (currently 478 patients, room to grow).",
        ],
      },
    ],
  },
};

/* Location AI Summary mock */
export const CP_LOCATION_SUMMARY = {
  location: "Beachview",
  period: "2026-01 to 2026-02",
  months: 2,
  revenue: "$283,840",
  collected: "$277,592 collected",
  collectionRate: "97.8%",
  appointments: "2,517",
  assessments: "233 assessments",
  issues: "281",
  issuesBreakdown: "18 no-show · 263 cancel",
  signals: [
    { tone: "watch", title: "Elevated Cancellations",  chip: "Watch", body: "13.1% cancellation rate",              foot: "Above 10% — monitor trend" },
    { tone: "win",   title: "Excellent Collection",    chip: "Win",   body: "97.8% collection rate",                foot: "Strong payment recovery" },
    { tone: "win",   title: "Peak Revenue Month",      chip: "Win",   body: "2026-01 — $144,180",                   foot: "Best performing month in this period" },
    { tone: "win",   title: "Strong New Patient Flow", chip: "Win",   body: "233 assessments (9.3% of appointments)",foot: "Healthy new patient intake" },
    { tone: "win",   title: "Top Practitioner",        chip: "Win",   body: "Marcus Donnell, PT #44021 — 517 appointments", foot: "10.4% cancellation rate · 28 assessments" },
  ],
  aiSummary:
    "During the period from January to February 2026, the Beachview wellness clinic generated a strong total revenue of $283,840, maintaining a 97.8% collection rate, which reflects excellent revenue-cycle hygiene. The clinic facilitated 2,517 appointments, including 233 new patient assessments, indicating healthy demand. The team experienced 18 no-shows and 263 cancellations, suggesting an opportunity to tighten appointment adherence through SMS confirmation and same-day waitlist offers. Revenue dipped slightly from $144,180 in January to $139,660 in February. A targeted plan to reduce cancellations and add 1–2 practitioners would lift utilisation and unlock approximately $42k/mo in additional revenue.",
  notes: [
    "Total Revenue: $283,840 over 2 months",
    "Collection Rate: 97.8% ($277,592 collected of $283,840)",
    "Total Appointments: 2,517 with 233 new patient assessments",
    "Reliability: 0.7% no-show rate, 13.1% cancellation rate",
    "Best Month: 2026-01 — $144,180 revenue",
    "Top Practitioner: Marcus Donnell, PT #44021 — 517 appointments",
  ],
};
